import PropTypes from "prop-types";
import styles from "./TabBar.module.css";
import React, { useState } from "react";

import GroupIcon from "./Icons/Group.svg";
import Tree from "./Icons/LOS_Tree_Icon_Gray.svg";
import New from "./Icons/New.svg";
import Group2Icon from "./Icons/Group2.svg";
import Group3Icon from "./Icons/Group3.svg";
import Group4Icon from "./Icons/Group4.svg";
import Group5Icon from "./Icons/Group5.svg";
import { useTranslation } from "react-i18next";

export function TabBar({
  onClick,
  chartView,
  changeView,
  selectedTab,
  downlineCountsData,
  isLOS = false,
  showDivider = true,
  totalLabel,
}) {
  const { t } = useTranslation();
  const [view, setView] = useState(chartView);
  const [branchView, setBranchView] = useState(true);
  const selected = selectedTab;

  const onViewChange = () => {
    setView(!view);
    changeView(!view);
  };

  const onSelectedChange = (tab) => {
    if (onClick) onClick(tab);
  };

  return (
    <>
      <div className={`${styles.container} ${isLOS ? styles.selectable : ""}`}>
        <div className={styles.header}>
          {!view &&
            (branchView ? (
              <div
                className={styles.chart}
                onClick={() => setBranchView(!branchView)}
              >
                <img src={Group2Icon} className={styles.chartIcon2} />
                <img src={Group3Icon} className={styles.chartIcon2} />
              </div>
            ) : (
              <div
                className={styles.chart}
                onClick={() => setBranchView(!branchView)}
              >
                <img src={Group4Icon} className={styles.chartIcon2} />
                <img src={Group5Icon} className={styles.chartIcon2} />
              </div>
            ))}

          {view && (
            <div
              className={selected == 0 ? styles.selected : styles.col}
              onClick={() => onSelectedChange(0)}
            >
              {selected == 0 && <img src={New} className={styles.new} />}
              <div className={styles.title}>{totalLabel || t("Total")}</div>
              <div
                className={styles.metricValue}
                style={{
                  color:
                    downlineCountsData.total.trend === "up"
                      ? "#43BA32"
                      : downlineCountsData.total.trend === "same"
                      ? "#FF9A00"
                      : downlineCountsData.total.trend === "down"
                      ? "#ED1F24"
                      : undefined,
                }}
              >
                {downlineCountsData.total.value}
              </div>
            </div>
          )}

          {/* {view && onClick !== null && (
            <div className={styles.verticalDivider} />
          )} */}

          {view && (
            <div
              className={selected == 1 ? styles.selected : styles.col}
              onClick={() => onSelectedChange(1)}
            >
              {selected == 1 && <img src={New} className={styles.new} />}
              <div className={styles.title}>Personal</div>
              <div
                className={styles.metricValue}
                style={{
                  color:
                    downlineCountsData.personal.trend === "up"
                      ? "#43BA32"
                      : downlineCountsData.personal.trend === "same"
                      ? "#FF9A00"
                      : downlineCountsData.personal.trend === "down"
                      ? "#ED1F24"
                      : undefined,
                }}
              >
                {downlineCountsData.personal.value}
              </div>
            </div>
          )}

          {view && (
            <div
              className={selected == 2 ? styles.selected : styles.col}
              onClick={() => onSelectedChange(2)}
            >
              {selected == 2 && <img src={New} className={styles.new} />}
              <div className={styles.title}>{t("Eagles")}</div>
              <div
                className={styles.metricValue}
                style={{
                  color:
                    downlineCountsData.eagles.trend === "up"
                      ? "#43BA32"
                      : downlineCountsData.eagles.trend === "same"
                      ? "#FF9A00"
                      : downlineCountsData.eagles.trend === "down"
                      ? "#ED1F24"
                      : undefined,
                }}
              >
                {downlineCountsData.eagles.value}
              </div>
            </div>
          )}

          {view && (
            <div
              className={
                onClick !== null && view
                  ? selected == 3
                    ? styles.selected
                    : styles.lastCol
                  : styles.col
              }
              onClick={() => onSelectedChange(3)}
            >
              {selected == 3 && <img src={New} className={styles.new} />}
              <div className={styles.title}>{t("Platinums")}</div>
              <div
                className={styles.metricValue}
                style={{
                  color:
                    downlineCountsData.platinums.trend === "up"
                      ? "#43BA32"
                      : downlineCountsData.platinums.trend === "same"
                      ? "#FF9A00"
                      : downlineCountsData.platinums.trend === "down"
                      ? "#ED1F24"
                      : undefined,
                }}
              >
                {downlineCountsData.platinums.value}
              </div>
            </div>
          )}
        </div>

        {!isLOS && showDivider && <div className={styles.divider} />}
      </div>
    </>
  );
}

TabBar.propTypes = {
  onClick: PropTypes.func,
  chartView: PropTypes.bool,
  changeView: PropTypes.func,
  selectedTab: PropTypes.number,
  downlineCountsData: PropTypes.object,
  isLOS: PropTypes.bool,
  showDivider: PropTypes.bool,
  totalLabel: PropTypes.string,
};
